import { httpClient } from "utils";
import { EMISSIONS_ALLOCATION_API_PATHS } from "./consts";
import { CreateEmissionsAllocationRequestBody, EmissionsAllocationDetails, EmissionAllocation, UpdateEmissionsAllocationRequestBody, AddEmissionsAllocationDimensionsRequestBody, EmissionsAllocationOverviewRequestBody, EmissionsAllocationExportRequestBody } from "./types";

// Emissions Allocation - Site Management page 
export const createEmissionsAllocation = async (body: CreateEmissionsAllocationRequestBody): Promise<EmissionsAllocationDetails> => {
    const response = await httpClient.post(EMISSIONS_ALLOCATION_API_PATHS.EMISSIONS_ALLOCATION, body);
    return response.data;
};

export const addEmissionsAllocationDimensions = async (body: AddEmissionsAllocationDimensionsRequestBody): Promise<EmissionsAllocationDetails> => {
    const response = await httpClient.post(EMISSIONS_ALLOCATION_API_PATHS.ADD_EMISSIONS_ALLOCATION_DIMENSIONS, body);
    return response.data;
};

export const updateEmissionsAllocation = async (body: UpdateEmissionsAllocationRequestBody): Promise<EmissionsAllocationDetails> => {
    const response = await httpClient.put(EMISSIONS_ALLOCATION_API_PATHS.UPDATE_EMISSIONS_ALLOCATION, body);
    return response.data;
};

export const deleteEmissionsAllocation = async (id: number): Promise<void> => {
    await httpClient.delete(EMISSIONS_ALLOCATION_API_PATHS.DELETE_EMISSIONS_ALLOCATION(id));
};

export const deleteEmissionsAllocationDimension = async (
    allocationId: number,
    dimension: string
): Promise<EmissionsAllocationDetails> => {
    const response = await httpClient.delete(
        EMISSIONS_ALLOCATION_API_PATHS.DELETE_EMISSIONS_ALLOCATION_DIMENSION(allocationId, dimension)
    );
    return response.data;
};

export const getAllEmissionsAllocations = async (): Promise<EmissionAllocation[]> => {
    const response = await httpClient.get(EMISSIONS_ALLOCATION_API_PATHS.EMISSIONS_ALLOCATION);
    return response.data;
};

export const getEmissionAllocationById = async (id: number): Promise<EmissionsAllocationDetails> => {
    const response = await httpClient.get(EMISSIONS_ALLOCATION_API_PATHS.EMISSION_ALLOCATION(id));
    return response.data;
};

export const getEmissionsAllocationCSV = async (id: number) => {
    const response = await httpClient.get(EMISSIONS_ALLOCATION_API_PATHS.EMISSION_ALLOCATION_CSV(id), { responseType: "arraybuffer" });
    return response.data;
};

export const downloadAllocationTemplate = async (id: number) => {
    const response = await httpClient.get(EMISSIONS_ALLOCATION_API_PATHS.DOWNLOAD_ALLOCATION_TEMPLATE(id), { responseType: "text" });
    return response.data;
};

export const uploadAllocationTemplate = async (id: number, file: File) => {
    const formData = new FormData();
    formData.append('file', file);
    await httpClient.post(EMISSIONS_ALLOCATION_API_PATHS.UPLOAD_ALLOCATION_TEMPLATE(id), formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        },
    });
};

// Emissions Allocation - Emission Overview page 

export const getEmissionsAllocationOverview = async (query: EmissionsAllocationOverviewRequestBody) => {
    const response = await httpClient.get(EMISSIONS_ALLOCATION_API_PATHS.EMISSIONS_ALLOCATION_OVERVIEW(query));
    return response.data;
};

export const exportEmissionsAllocationSummary = async (query: EmissionsAllocationExportRequestBody) => {
    const response = await httpClient.get(EMISSIONS_ALLOCATION_API_PATHS.EMISSIONS_ALLOCATION_SUMMARY_EXPORT(query), {
        responseType: "arraybuffer"
    });
    return response.data;
};